import {
  RESET_SHIPPING_ADDRESS,
  RESET_TAX,
  UPDATE_SHIPPING_ADDRESS,
  UPDATE_TAX,
  UPDATE_PAYMEMT_ACCOUNT_SUCCESS,
  SET_PAYPAL_ERROR,
  TAX_UNAVAILABLE,
  SUCCESSFUL_PAYMENT,
  CLEAR_CHECKOUT,
} from '../Types';

const initialState = {
  totalTax: 0,
  isTaxError: false,
  billingAddress: {},
  hasShippingAddress: false,
  shippingAddress: null,
  hasAccountUpdated: false,
  paypalError: '',
  successfulPaymentCompleted: false,
};

export const checkout = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TAX:
      const { totalTax = 0, isTaxError = false, billingAddress = {} } = action.payload;
      return { ...state, totalTax, isTaxError, billingAddress };
    case RESET_TAX:
      return { ...state, totalTax: 0, isTaxError: false, billingAddress: {} };
    case TAX_UNAVAILABLE:
      return { ...state, totalTax: 0, isTaxError: true };
    case UPDATE_SHIPPING_ADDRESS:
      return { ...state, hasShippingAddress: true, shippingAddress: action.payload };
    case RESET_SHIPPING_ADDRESS:
      return { ...state, hasShippingAddress: false, shippingAddress: null };
    case UPDATE_PAYMEMT_ACCOUNT_SUCCESS:
      return { ...state, hasAccountUpdated: true };
    case SET_PAYPAL_ERROR:
      return { ...state, paypalError: action.payload };
    case SUCCESSFUL_PAYMENT:
      return {
        ...state,
        successfulPaymentCompleted: true,
      };
    case CLEAR_CHECKOUT:
      return { ...state, ...initialState };
    default:
      return state;
  }
};
